import React, { useState, useEffect } from 'react';
import 'swiper/css';
import { useTranslation } from 'react-i18next';
import Slider from '../Slider/Slider';

const SeatsAvailableOpenTable = ({ intervals, onSeatChange, selectedSeatType }) => {
  const { t } = useTranslation();
  const [seatOptions, setSeatOptions] = useState([]);
  const [selectedSeatOption, setSelectedSeatOption] = useState(selectedSeatType || '');

  const translateAttribute = (attr) => {
    switch (attr) {
      case 'default':
        return t('translateAttribute.default');
      case 'counter':
        return t('translateAttribute.counter');
      case 'highTop':
        return t('translateAttribute.highTop');
      case 'outdoor':
        return t('translateAttribute.outdoor');
      case 'bar':
        return t('translateAttribute.bar');
      default:
        return attr;
    }
  };

  useEffect(() => {
    if (!intervals || intervals.length === 0) {
      setSeatOptions([]);
      setSelectedSeatOption('');
      return;
    }

    const allAttributes = intervals.flatMap((interval) => interval.attributes);
    const uniqueAttributes = Array.from(new Set(allAttributes));
    const options = uniqueAttributes.map((attr, index) => ({
      id: index + 1,
      label: translateAttribute(attr),
      value: attr,
    }));

    setSeatOptions(options);

    if (selectedSeatType) {
      setSelectedSeatOption(selectedSeatType);
    } else if (options.length > 0) {
      setSelectedSeatOption(options[0].value);
    }
  }, [intervals, selectedSeatType]);

  useEffect(() => {
    if (onSeatChange) {
      onSeatChange(selectedSeatOption);
    }
  }, [selectedSeatOption, onSeatChange]);

  return (
    <>
      <div className="mt-3 mb-2 mb-1 text-secondary bold">{t('seatingOptionsAvailable')}</div>
      <div className="mb-4">
        <Slider
          slideSpacing={10}
          initialSlide={0}
          touchScroll={true}
          showBtns={false}
          visibleSlides={'all'}
        >
          {seatOptions.map((option) => (
            <div key={option.id}>
              <button
                className={`btn btn-primary selector text-left font-tiny btn-square nowrap ${
                  selectedSeatOption === option.value ? 'selected-seat' : 'btn-outline'
                }`}
                onClick={() => setSelectedSeatOption(option.value)}
              >
                {option.label}
              </button>
            </div>
          ))}
        </Slider>
      </div>
    </>
  );
};

export default SeatsAvailableOpenTable;
